<template>
  <div
    ref="ShareImageRef"
    class="share-image-wrapper flex-col-center"
    :class="[gameName, displayLayout]"
    @click="downloadToImage"
  >
    <!-- 勋章 -->
    <img
      v-lazy="require(`@/assets/images/member/medal_${level}.png`)"
      :alt="`medal image ${level}`"
      class="medal-image"
      v-if="level"
    />
    <!-- 用户信息 -->
    <div class="info">
      <!-- 用户名 -->
      <p class="username">{{ userInfo?.userName || '' }}</p>
      <!-- 最近购买的游戏信息 - 注：服务端定时执行，不一定是最近购买的 -->
      <div class="game-info flex-start">
        <img
          v-lazy="gameLogo"
          class="game-logo"
          crossorigin="anonymous"
          :alt="`${gameName} logo`"
        />
        <span class="game-desc">{{ gameDesc }}</span>
      </div>
      <!-- 消费信息 -->
      <div class="consumption-info space-between">
        <!-- 消费金额 -->
        <div class="consumption-item">
          <span class="title">{{ $t('memberShare.consumed') }}</span>
          <span class="value consumed">
            <MoneyDisplay
              :number="Number(members?.userInfo?.spendingExp || 0)"
              :allowShowKcoin="true"
              :isKwalletSelected="isKwalletSelected()"
            />
          </span>
        </div>
        <!-- 超过xx -->
        <div class="consumption-item exceed">
          <span class="title">{{ $t('memberShare.exceed') }}</span>
          <span class="value">{{ surpassPercentByLevel }}</span>
        </div>
      </div>
      <!-- toplupe信息 -->
      <div class="toplupe-info">
        <img
          v-lazy="
            require(`@/assets/images/detail/mobile-legends/desktop/new-hander-logo.png`)
          "
          class="toplupe-logo"
          :alt="`toplupe logo`"
        />
        <p class="url">{{ hostname }}</p>
      </div>
    </div>
  </div>
</template>
<script>
  // 分享图片
  import MoneyDisplay from '@/components/MoneyDisplay'
  import html2canvas from 'html2canvas'
  import { mapState, mapGetters } from 'vuex'
  import { currentLevelShort, surpassPercent } from '@/utils/members'
  import { getUserRecentGame } from '@/api/member'
  import { gameTopLupe } from '@page_detail/config'

  export default {
    props: {
      levelCode: {
        type: [Number, String],
        default: '',
      },
      from: {
        type: String,
        default: 'banner', // 分享来源:banner/toast升级弹窗
      },
    },
    components: {
      MoneyDisplay,
    },
    data() {
      return {
        gameData: {},
        gameLogo: require(`@/assets/images/member/game-logo.png`), // 游戏logo
        loading: false, // 是否在请求中
        hostname: '',
      }
    },
    computed: {
      ...mapState(['members', 'userInfo', 'region']),
      ...mapGetters(['displayLayout']),
      level() {
        return currentLevelShort(this.levelCode)
      },
      // 超越xx.xx%用户
      surpassPercentByLevel() {
        return surpassPercent(this.levelCode)
      },
      // 游戏名称
      gameName() {
        const game = this.gameData?.game || ''
        return game.toLocaleLowerCase()
      },
      // 游戏描述
      gameDesc() {
        // 最近购买的是K币或者点卡时
        if (this.isKwalletSelected()) {
          return this.$t('memberShare.toplupeUser')
        }
        // 其他游戏
        return this.$t('memberShare.player', {
          game: this.gameData?.showName,
        })
      },
    },
    watch: {
      userInfo() {
        this.init()
      },
    },
    mounted() {
      this.init()
      if (process.client) {
        this.hostname = window?.location?.hostname || ''
      }
    },
    methods: {
      init() {
        // 用户登录后调用获取游戏接口
        if (this.userInfo?.kicoinId) {
          this.getGameName()
        }
      },
      // 查询当前登录用户最近购买的游戏
      getGameName() {
        if (this.loading) return
        this.loading = true
        getUserRecentGame(this.region)
          .then((res) => {
            this.gameData = res
            const defaultIcon = require(`@/assets/images/member/game-logo.png`)
            if (res?.gameIcon) {
              this.getBase64Image(res?.gameIcon)
                .then((base64) => {
                  this.gameLogo = base64
                })
                .catch(() => {
                  this.gameLogo = defaultIcon
                })
            } else {
              this.gameLogo = defaultIcon
            }
          })
          .finally(() => {
            this.loading = false
          })
      },
      isKwalletSelected() {
        return this.gameName === gameTopLupe
      },
      // 根据dom生成图片
      downloadToImage() {
        // 注:导出的图片和dom元素不一定100%一致
        let params = {}
        if (
          this.$refs.ShareImageRef &&
          this.$refs.ShareImageRef?.getBoundingClientRect()
        ) {
          // 用于解决导出图片白边问题
          params = {
            width: this.$refs.ShareImageRef.getBoundingClientRect().width,
            height: this.$refs.ShareImageRef.getBoundingClientRect().height,
          }
        }
        // 生成canvas
        html2canvas(this.$refs.ShareImageRef, params).then((canvas) => {
          // 生成图片的dataurl
          const url = canvas.toDataURL('image/png')
          // 注：由于小米浏览器存在导出图片时资源大小为0的情况，因此需要转为blob格式
          // 参考文档：https://juejin.cn/post/7147613444647157768
          const blob = this.base64ToBlob(url)
          const blobHref = URL.createObjectURL(blob)
          this.download(blobHref)
        })
      },
      // base64转blob
      base64ToBlob(code) {
        const parts = code.split(';base64,')
        const contentType = parts[0].split(':')[1]
        const raw = window.atob(parts[1])
        const rawLength = raw.length
        const uInt8Array = new Uint8Array(rawLength)
        for (let i = 0; i < rawLength; ++i) {
          uInt8Array[i] = raw.charCodeAt(i)
        }
        return new Blob([uInt8Array], {
          type: contentType,
        })
      },
      // 导出图片
      download(url) {
        let aTag = document.createElement('a')
        aTag.href = url
        aTag.download = `toplupe-${new Date().getTime()}.png`
        aTag.dispatchEvent(new MouseEvent('click'))
      },
      // 取消
      cancel() {
        this.$emit('cancel')
      },
      // 跨域问题处理 - 将https的地址的图片转为base64
      // 注: 如果不处理可能会出现图片丢失问题
      getBase64Image(url) {
        return new Promise((resolve, reject) => {
          const image = new Image()
          image.src = url + '?v=' + Math.random() // 处理缓存
          image.crossOrigin = '*' // 支持跨域图片
          image.onload = () => {
            resolve(this.drawBase64Image(image))
          }
          image.onerror = () => {
            reject('image error')
          }
        })
      },
      drawBase64Image(img) {
        const canvas = document.createElement('canvas')
        canvas.width = img.width
        canvas.height = img.height
        const ctx = canvas.getContext('2d')
        ctx.drawImage(img, 0, 0, img.width, img.height)
        const dataURL = canvas.toDataURL('image/png')
        return dataURL
      },
    },
    // end
  }
</script>

<style scoped lang="scss" src="./ShareImage.scss"></style>
<style scoped lang="scss" src="./ShareImage_gt.scss"></style>
<style scoped lang="scss" src="./ShareImage_pc.scss"></style>
